import React from "react";
import { Users, Wifi } from "lucide-react";
import { useVisitTotal } from "../hooks/useVisitorSession";
import { useHeartbeat } from "../hooks/useHeartbeat";

const NUMBER_FORMAT = new Intl.NumberFormat("pt-BR");
const formatCount = (n) => (n === null ? "—" : NUMBER_FORMAT.format(n));

const PingDot = ({ outer, inner }) => (
  <span className="relative flex w-2 h-2">
    <span className={`absolute inline-flex w-full h-full rounded-full ${outer} opacity-75 animate-ping`} />
    <span className={`relative inline-flex w-2 h-2 rounded-full ${inner}`} />
  </span>
);

const CounterPill = ({ testId, className, dot, icon, label, value }) => (
  <div data-testid={testId} className={`inline-flex items-center gap-2.5 px-4 py-2 rounded-full backdrop-blur-sm ${className}`}>
    {dot}
    {icon}
    <span className="text-[11px] text-white/60 uppercase tracking-wider font-semibold">{label}</span>
    <span data-testid={`${testId}-number`} className="text-sm font-extrabold text-white tabular-nums">
      {formatCount(value)}
    </span>
  </div>
);

export default function VisitorCounter() {
  const count = useVisitTotal();
  const online = useHeartbeat();

  return (
    <div className="mt-2 flex flex-wrap items-center justify-center gap-3">
      <CounterPill
        testId="visitor-counter"
        className="bg-white/5 border border-white/10"
        dot={<PingDot outer="bg-brand-light" inner="bg-brand" />}
        icon={<Users className="w-3.5 h-3.5 text-brand-light" />}
        label="Visitantes:"
        value={count}
      />
      <CounterPill
        testId="online-counter"
        className="bg-[#25D366]/10 border border-[#25D366]/30"
        dot={<PingDot outer="bg-[#25D366]" inner="bg-[#25D366]" />}
        icon={<Wifi className="w-3.5 h-3.5 text-[#25D366]" />}
        label="Online agora:"
        value={online}
      />
    </div>
  );
}
